import React  from "react";
import { Col, Row, Container } from 'react-bootstrap'
import { useTranslation } from 'react-i18next';
import { Chrono } from "react-chrono";
import powerlooms from '../../assests/images/powerlooms.webp';
import Pakistan from '../../assests/images/pakistan.png'
import Shuttless from '../../assests/images/Shuttless.webp';
import Sizing from '../../assests/images/sizing.jpg';
import Intersec2015 from '../../assests/images/Intersec-2015.jpg';
import PPE from '../../assests/images/ppe.jpg';
import APlusA2023 from '../../assests/images/a+a.jpg';
import NSCExpo2024 from '../../assests/images/nsc.jpg';
import Qatar2019 from '../../assests/images/qatar2019.jpg';
import UAE2016 from '../../assests/images/UAE2016.jpeg';

import 'bootstrap/dist/css/bootstrap.min.css';
import './milestones.css';

const Milestones = () => {
    const { t } = useTranslation();
    const items = [
        {
            title: "2024",
            cardTitle: "NSC Safety Congress & Expo (USA)",
            cardSubtitle: "NSC Safety Congress & Expo Participations",
            cardDetailedText:`Participated in NSC Safety Congress & Expo for the promotion of the products and 
            services in the American market`,
            media: {
                type: "IMAGE",
                source: {
                    url: NSCExpo2024
                }
            }
        },
        {
            title: "2023",
            cardTitle: "A+A European Expo (Europe)",
            cardSubtitle: "A+A European Exhibition Participations",
            cardDetailedText:`Participated in A+A European Exhibitions for the promotion of the products and 
            services in the European market.`,
            media: {
                type: "IMAGE",
                source: {
                    url: APlusA2023
                }
            }
        },
        {
            title: "2019",
            cardTitle: "Qatar Exhibition (Qatar)",
            cardSubtitle: "Intersec Exhibition Presentation, UAE",
            cardDetailedText:`Shareef tex presentated in Qatar on 2019. Safety. 
            Presenting wide categories of personal protective equipments like coverall, safety gloves`,
            media: {
                type: "IMAGE",
                source: {
                    url: Qatar2019
                }
            }
        },
        {
            title: "2016",
            cardTitle: "Intersec Exhibition (UAE)",
            cardSubtitle: "Intersec Exhibition Presentation, UAE",
            cardDetailedText:`Shareef tex global presentation on Intersec UAE in 2016. Safety Gloves exporter and manufacturer specializing in different types of gloves 
            such as hot mill, double palm, drill, terry, jersey, seamless, Interlock, and Lisle, nylon,
            chores, leather working gloves, grain leather, welding, tig/mitten, water & oil resistance, mechanical,
            aluminized, and full body leather suits.`,
            media: {
                type: "IMAGE",
                source: {
                    url: UAE2016
                }
            }
        },
        {
            title: "2015",
            cardTitle: "Intersec Exhibition (UAE)",
            cardSubtitle: "Intersec Exhibition Presentation, UAE",
            cardDetailedText:`Shareef tex global presentation on Intersec UAE in 2015. Safety Gloves exporter and manufacturer specializing in different types of gloves 
            such as hot mill, double palm, drill, terry, jersey, seamless, Interlock, and Lisle, nylon,
            chores, leather working gloves, grain leather, welding, tig/mitten, water & oil resistance, mechanical,
            aluminized, and full body leather suits.`,
            media: {
                type: "IMAGE",
                source: {
                    url: Intersec2015
                }
            }
        },
        {
            title: "2012",
            cardTitle: "Personal Protective Equipments Manufacturing",
            cardSubtitle: "Import and Export",
            cardDetailedText:`Started the export and manufacturering of cotton & leather coverall, aprons, 
            high visibility clothing, boots, glasses, helmets, fire retardant clothing, hi-vis pants, hi-vis vests, 
            and full body suits,`,
            media: {
                type: "IMAGE",
                source: {
                    url: PPE
                }
            }
        },
        {
            title: "2006",
            cardTitle: "Sizing",
            cardSubtitle:"Sizing Installments",
            cardDetailedText:"Installments of two units of Sizings for production of efficient, quality fabrics and effective costing.",
            media: {
                type: "IMAGE",
                source: {
                    url: Sizing
                }
            }
        },
        {
            title: "2000",
            cardTitle: "Weaving Advancements",
            cardSubtitle:"Shuttleless Looms",
            cardDetailedText:`Installation of shuttleless looms for advancing production, enhancing quality, and diversifying offerings. 
            Also, inclusion of the varity of fabircs such as cotton, polyester, and demin.`,
            media: {
                type: "IMAGE",
                source: {
                    url: Shuttless
                }
            }
        },
        {
            title: "1995",
            cardTitle: "Nationwide Expansion",
            cardSubtitle:"Nationwide trading and production expansion",
            cardDetailedText:`Addition of hundered plus powerlooms machines over the city to fasten up the production and yarn trading nationally.`,
            media: {
                type: "IMAGE",
                source: {
                    url: Pakistan
                }
            }
        },
        {
            title: "1980",
            cardTitle: "Founded",
            cardSubtitle: "Founded in 1980 by Mr. Shareef",
            cardDetailedText:`Shareef Tex was founded by Mr. Shareef in Faisalabad, Punjab, Pakistan. 
            They started manufacturering grey clothes and yarn trading locally.`,
            media: {
                type: "IMAGE",
                source: {
                    url: powerlooms
                }
            }
        },
    ];
    return (
        <section className="milestones">
            <Container>
                <Row>
                    <h2 className="milestones-heading">{t("highlights")}</h2>
                </Row>
                {/* slider */}
                <Row className="d-flex justify-content-center">
                    <Col>
                        <div style={{ width: "1300px", height: "700px",  }}>
                            <Chrono items={items}  mode="HORIZONTAL" reverse />
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default Milestones;